import VPagination from './VPagination'

/* istanbul ignore next */
VPagination.install = function install (Vue) {
  Vue.component(VPagination.name, VPagination)
}

export default VPagination



// WEBPACK FOOTER //
// ./src/components/VPagination/index.js